import React from 'react';

const Contact = () => {


    return (
        <section id="contact" className='py-5 text-center'>
            <div className="container hidden contact">
                <h2 className="title">Contact Me</h2>
                <h1>Get In Touch</h1>
                <p>Feel free to reach out to me for any inquiries or opportunities.</p>

                <a href="mailto:cheungkh.chris@gmail.com" className="email-button" rel="noopener noreferrer" target="_blank">Email Me</a>
            </div>
        </section >
    );
};

export default Contact;